import React, { memo } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Formik } from "formik";
import { UserMetadata } from "../../types";
import TextField from "../TextField";
import Button from "../Button";

type Props = {
  onFinish: () => void;
  onForgotPassword: (email: string, actions: any) => Promise<void>;
};

const ForgotPasswordForm = memo(({ onFinish, onForgotPassword }: Props) => {
  return (
    <div className="flex-col max-w-4xl mx-auto px-2 mt-8 sm:px-6 lg:px-4  lg:mt-16">
      <div className="md:shadow-lg md:p-8 flex-col items-center">
        <h1 className="h1 mb-2">FORGOT PASSWORD</h1>
        <p className="text-md text-center mb-8">
          Enter your email address
        </p>
        <Formik
          validateOnBlur={false}
          initialValues={{
            email: "",
            error: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .trim()
              .required("Please enter your email address.")
              .email("Must be a valid email."),
          })}
          onSubmit={({ error, email }, actions) => {
            onForgotPassword(email, actions)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              onSubmit={handleSubmit}
              noValidate
              className="max-w-lg mx-auto flex flex-col items-center"
            >
              <ErrorMessage name="error" />
              <TextField
                type="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                showError={touched.email && Boolean(errors.email)}
                required
                id="email"
                name="email"
                autoComplete="email"
                placeholder="Email"
              />
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full btn bg-gradient text-kyzzen-primary font-medium"
              >
                REQUEST PASSWORD
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
});

export default ForgotPasswordForm;
